import React, { useState } from 'react';

function LocationStep({ centers, selectedCenter, onCenterSelect }) {
  const [expandedCard, setExpandedCard] = useState(null);

  function toggleExpand(e, centerId) {
    e.stopPropagation();
    setExpandedCard(prev => prev === centerId ? null : centerId);
  }

  return (
    <div className="step-content">
      <h1 className="step-title">WHERE WOULD YOU LIKE TO GO?</h1>
      <div className="location-cards-grid">
        {centers.map(c => {
          const isExpanded = expandedCard === c.id;
          const isSelected = selectedCenter?.id === c.id;
          return (
            <div
              key={c.id}
              className={`location-row ${isSelected ? 'selected' : ''}`}
              onClick={() => onCenterSelect(c)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onCenterSelect(c); } }}
            >
              <div className="location-row-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              </div>
              <div className="location-row-text">
                <h3 className="location-row-name">{c.name}</h3>
                <p className="location-row-address">{c.address}</p>
                <button className="location-more-btn" onClick={(e) => toggleExpand(e, c.id)}>
                  {isExpanded ? 'Less info \u2039' : 'More info \u203A'}
                </button>
                <div className={`location-details ${isExpanded ? 'expanded' : ''}`}>
                  {c.phone && (
                    <div className="location-detail-row">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                      <a href={`tel:${c.phone.replace(/[^0-9]/g, '')}`} onClick={(e) => e.stopPropagation()}>{c.phone}</a>
                    </div>
                  )}
                  {c.hours && (
                    <div className="location-detail-row">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                      <span>{c.hours}</span>
                    </div>
                  )}
                  {c.mapUrl && (
                    <div className="location-detail-row">
                      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>
                      <a href={c.mapUrl} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>Get directions</a>
                    </div>
                  )}
                </div>
              </div>
              <div className="location-row-chevron" aria-hidden="true">›</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default LocationStep;
